import Overview from 'Components/CompetitionAnalysis/CompetitionGroup/Dashboard/Overview';
import React, { useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { fetchCompeitionGroupThunk } from 'slices/competitionAnalysis/thunk';
import { AppDispatch, RootState } from 'store';

const CompetitorAnalysisPreview: React.FC<{ reportId: string }> = ({ reportId }) => {

    const competitionGroup = useSelector((state: RootState) => state.competitionAnalysis.group[reportId]?.data);
    const tiers = useSelector((state: RootState) => state.competitionAnalysis.group[reportId]?.creator_follower_tiers);
    const [loading, setLoading] = useState(false);
    const dispatch: AppDispatch = useDispatch();

    useEffect(() => {
        if (reportId) {
            setLoading(true);
            dispatch(fetchCompeitionGroupThunk({ competitionGroupId: reportId })).finally(() => setLoading(false));
        }
    }, [reportId])
    
    return (
        <div className='dashboard-section'>
            <div className="dashboard-section-header">
                <h5>Competitor Analysis</h5>
                <Link className='dashboard-section-header-view-more' to={{ pathname: '/competitor/'+reportId }}>View All</Link>
            </div>
            <div className="dashboard-section-body">
                {
                    loading ? <Skeleton height={380} className='rounded' /> : <Overview competitionGroup={competitionGroup} tiers={tiers} preview /> 
                }
            </div>
        </div>
    )
}

export default CompetitorAnalysisPreview